import { useOnEvent } from '@fluentui/react-hooks';
import { createContext, type FC, type PropsWithChildren, useCallback, useState } from 'react';

export const ModelerIsDirtyContext = createContext<boolean>(false);

type TCustomEvent = CustomEvent<boolean>;

const eventName = 'modelerIsDirty';

export const ModelerIsDirtyProvider: FC<PropsWithChildren> = (props) => {
    const [isDirty, setIsDirty] = useState<boolean>(false);

    useOnEvent<HTMLBodyElement, TCustomEvent>(
        document,
        eventName,
        useCallback((event) => {
            setIsDirty(event.detail);
        }, [])
    );

    return (
        <ModelerIsDirtyContext.Provider value={isDirty}>
            {props.children}
        </ModelerIsDirtyContext.Provider>
    );
};

export const triggerModelerIsDirty = (isDirty: boolean): void => {
    document.dispatchEvent(new CustomEvent(eventName, { detail: isDirty }));
};
